import { useState } from "react";
import "./index.css";

import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomeSection } from "./components/HomeSection";
import { QuemSomosSection } from "./components/QuemSomosSection";
import { EstandarteSection } from "./components/EstandarteSection";
import { ContatoSection } from "./components/ContatoSection";

export function App() {
  const [activeTab, setActiveTab] = useState<string>("home");
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

  const navigateTo = (pageId: string) => {
    setActiveTab(pageId);
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="antialiased flex flex-col min-h-screen">
      {/* MENU DE NAVEGAÇÃO SUPERIOR */}
      <Header
        activeTab={activeTab}
        navigateTo={navigateTo}
        mobileMenuOpen={mobileMenuOpen}
        toggleMobileMenu={toggleMobileMenu}
      />

      {/* CONTENT CONTAINER (Onde as "páginas" são injetadas) */}
      <main className="grow flex flex-col">
        {activeTab === "home" && <HomeSection navigateTo={navigateTo} />}
        {activeTab === "quem-somos" && <QuemSomosSection />}
        {activeTab === "estandarte" && <EstandarteSection />}
        {activeTab === "contato" && <ContatoSection />}
      </main>

      {/* RODAPÉ */}
      <Footer />
    </div>
  );
}

export default App;
